import React from "react";

function Welcome() {
  return (
    <div className="welcome m-auto w-11/12 h-72">
      <ul>
        <li>Üdvözöljük a weboldalunkon.</li>
        <li>Válassza ki az érdeklődésének megfelelő sportokat. </li>
        <li>Jelentkezzen be vagy hozzon létre profilt. </li>
        <li>Szerezzen barátokat.</li>
        <li>Fedezzen fel új helyeket barátaival együtt.</li>
      </ul>
    </div>
  );
}

export default Welcome;
